import VideoPlayer from './VideoPlayer.vue';
import VideoPlayerStates from './VideoPlayerStates.js';

export const VideoStates = VideoPlayerStates;

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js